import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { getCompanyFromLocalStorage, hasPermission } from "./helper";
import { Permission } from "./constant";
import { useInternalCompaniesQuery } from "./queries/internal-companies.queries";
import { useMeQuery } from "./queries/me.queries";
import { redirectToLogout } from "./auth/auth.utils";
import { InviteService } from "./services/invite-service";

export default function RedirectToCompany() {
  const navigate = useNavigate();
  const { data: currentUser, isFetched: isCurrentUserFetched } = useMeQuery();
  const { data: companies = [], isFetched: isCompaniesFetched } =
    useInternalCompaniesQuery();

  useEffect(() => {
    async function doRedirect() {
      if (!isCurrentUserFetched || !isCompaniesFetched) return;
      if (!currentUser?.acceptedPrivacy) {
        navigate("/accept-privacy");
        return;
      }

      const isSystemAdmin = hasPermission(
        currentUser?.permissions,
        Permission.SYSTEM_ADMIN,
      );

      if (companies.length > 0) {
        const id = getCompanyFromLocalStorage();
        const isValidId = id && companies.find((company) => company.id === +id);
        const companyId = isValidId ? id : companies[0].id;
        sessionStorage.setItem("company-id", companyId.toString());
        navigate(`/${companyId}/users`);
      } else if (isSystemAdmin) {
        navigate(`/manage/companies`);
      } else if (currentUser && !currentUser.active) {
        redirectToLogout();
      } else {
        const pendingInvite = await InviteService.getPending();
        if (pendingInvite) {
          navigate(`/accept?id=${pendingInvite.inviteKey}`);
        } else {
          navigate(`/apps`);
        }
      }
    }

    // eslint-disable-next-line no-console
    doRedirect().catch(console.error);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCurrentUserFetched, isCompaniesFetched]);

  return null;
}
